// import MapContent from './SunlightMap/MapContent'
import SunlightMapContent from '../../Estimate/components/Sunlight/SunlightMapContent'
import BuildingShadow from './SunlightMap/BuildingShadow'

export { default } from './Sunlight'
export const SunlightMapConfig = {
  Content: SunlightMapContent,
  Controller: BuildingShadow,
}
